import { useCallback } from 'react';
export const useGetWebChatConfig = (token) => useCallback(async (data) => {
    const config = await fetch('/api/webchat', {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token.current}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((res) => (res.ok ? res.json() : undefined));
    if (config && config.directLineConfig.continueConversation) {
        config.directLineConfig.conversationId = config.directLineConfig.conversationIdForToken;
    }
    return config;
}, [token]);
//# sourceMappingURL=useGetWebChatConfig.js.map